// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiAnonymousClientCollectionTable/getTableSettings', payload).then(getData);

export const markAccepted = () => http.post('apiEula/accept').then(getData);

export const getEulaContent= () => http.post('apiEula/getEulaContent').then(getData);